import React from "react";

import { ErrorPage } from "./ErrorPage";

export const NotFound = () => (
    <ErrorPage
        title="Not found"
        message="The requested page does not exist."
        reload={false}
        logout={true}
    />
);
